<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="items"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              @click:row="getRow"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <autocomplete
                          ref="autocomplete"

                          :get-result-value="getResultValue"
                          :search="search"
                          @submit="onSubmit"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.availability="{item}">
                <v-checkbox
                  v-model="item.availability"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ServicePointService } from "@/views/loyalty/shared/services/service_point_service"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { getObjectsForSearching, getSearchedObjects } from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"

export default {
  name: "PointList",
  components: { Autocomplete },
  data: () => ({
    campaign: {},
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    items: [],
    headers: [
      {
        text: 'Номер',
        value: 'number',
      },
      {
        text: 'Наименование',
        value: 'name',
      },
      {
        text: 'Место обслуживания',
        value: 'placeHuman',
      },
      {
        text: 'Клиент',
        value: 'clientHuman',
      },
      {
        text: 'Доступность',
        value: 'availability',
      },
    ],
    loading: false,
    webApi: null,
  }),
  beforeMount () {
    this.webApi = new WebApi(this.$store).readError("Не удалось прочитать данные")
  },
  mounted () {
    console.clear()
    // this.campaign = this.$store.getters['campaign_store/getCampaign'].campaign
    this.campaign = localStock.getItem('campaign')
    console.log('this.campaign:', this.campaign)
    this.getItems()
  },
  methods: {
    getItems () {
      this.loading = true
      this.axios.post(`${process.env.VUE_APP_JUSTPAY_URL}api/point/list`, { id: null, page: 1, limit: -1 })
          .then(result => {
            console.log('result.data', result.data)
            // this.form.id = null
            if (!result.data.error) {
              // get service points for certain customer ID
              const servicePoints = result.data.data.filter(servicePoint => this.campaign.customerId === servicePoint.client)
              const servicePointService = new ServicePointService().add_point_clients(result.data.clients)
                  .add_point_places(result.data.places)
              this.items = servicePoints.map(m => {
                servicePointService.add_point_data(m)
                // console.log('servicePointService.item', servicePointService.item)
                return servicePointService.item
              })
            }
            this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/service_point/`).then((data) => {
              console.log('data', data)
              this.items = this.items.map(m => {
                const point = data.find(f => f.pointId === m.pointId && f.campaignId === this.campaign.campaignId)
                if (point !== undefined ? point.availability : false) {
                  m.availability = point.availability
                }
                return m
              })
            })
            this.loading = false
          })
          .catch(e => {
            this.loading = false
            console.log(e)
            // this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
    },
    getResultValue (result) {
      return result.searched
    },
    getRow (point) {
      console.log('getRow point', point)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/service_point/${this.campaign.campaignId}/${point.pointId}/${point.availability}`)
      // , { pointId: 'aaaa', availability: true }
    },
    onSubmit (result) {
      const searching = result.searched ? result.searched : result
      if (searching.length !== 0) {
        this.items = getObjectsForSearching(this.items, searching)
      } else {
        this.getItems()
      }
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = getSearchedObjects(this.items, input)
      console.log('arr', arr)
      return arr
    },
  }
}
</script>

<style scoped>

</style>
